import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Article from "./pages/Article";
import Tentang from "./pages/Tentang";
import NotFound from "./component/includes/not_found";
import ProductLayanan from "./pages/layanan/Product";
import ShowArticle from "./pages/ShowArtikel";
import RawatJalan from "./pages/layanan/RawatJalan";
import Dashboard from "./pages/Dashboard";
import LoginPage from "./pages/Auth/login";
import DashboardProduct from "./pages/Dashboard/product/productList";
import DashboardProductCategory from "./pages/Dashboard/product/productCategory";
import ProtectedRoute from "./services/Protected/ProtectedRoute";
import UnauthorizedPage from "./services/Protected/Unauthorized";
import DashboardServicePage from "./pages/Dashboard/Layanan/LayananList";
import ProductDetail from "./component/includes/product/Detail";
import DashboardProfile from "./pages/Dashboard/profile";
import DashboardTask from "./pages/Dashboard/profile/taskTentang";
import FunctionManagement from "./pages/Dashboard/profile/fungsiTentang";
import HistoryManagement from "./pages/Dashboard/profile/HistoryTentang";
import MisiManagement from "./pages/Dashboard/profile/MisiManagement";
import VisiManagement from "./pages/Dashboard/profile/VisiManagement";
import OrganizationStructureManagement from "./pages/Dashboard/profile/OrganisasiStruktur";
import DashboardServiceCategoryPage from "./pages/Dashboard/Layanan/Layanan-Category";
import NewsManagement from "./pages/Dashboard/News-Content";
import ArticleCategoryManagement from "./pages/Dashboard/Artikel/Category";
import ArticleManagement from "./pages/Dashboard/Artikel";
import Profile from "./pages/user/profile";
import EducationFileManagement from "./pages/Dashboard/Eduction_Student";
import NewsDetail from "./component/includes/berita/detail";
import News from "./pages/news";
import EducationManagement from "./pages/Eduction";
import InternshipRegistration from "./pages/Eduction";
import FacilityManagement from "./pages/Dashboard/Facility";
import FacilityDetail from "./pages/facility";
import PublicContentManagement from "./pages/Dashboard/public";
import FooterContent1Management from "./pages/Dashboard/alamat";
import FooterContent2Management from "./pages/Dashboard/maps";
import FooterContent3Management from "./pages/Dashboard/contact";
import Contact4Management from "./pages/Dashboard/timeline";
import FooterContent6Management from "./pages/Dashboard/sosialMedia";
import HeroContentManagement from "./pages/Dashboard/hero";
import DashboardUserPage from "./pages/Dashboard/user";
import PlantDetail from "./component/includes/tanaman";
import DashboardGallery from "./pages/Dashboard/Gallery";
import DashboardGalleryVideo from "./pages/Dashboard/video";
import ImageDetection from "./pages/Detection";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    const storageType = localStorage.getItem('storageType');
    const storage = storageType === 'local' ? localStorage : sessionStorage;
    const currentToken = storage.getItem('token');
    setToken(currentToken);

    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div className="flex flex-col justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-blue-500"></div>
        <p className="mt-4 text-xl font-semibold">Loading...</p>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/artikel" element={<Article />} />
        <Route path="/tentang" element={<Tentang />} />
        <Route path="/Education" element={<InternshipRegistration />} />
        <Route path="/identifikasi-tanaman" element={<ImageDetection />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/artikel/:id" element={<ShowArticle />} />
        <Route path="/berita/:id" element={<NewsDetail />} />
        <Route path="/berita" element={<News />} />
        <Route path="/fasilitas" element={<FacilityDetail/>} />
        <Route path="/layanan/:serviceSlug" element={<RawatJalan />} />
        <Route path="/layanan/produk-layanan" element={<ProductLayanan />} />
        <Route path="/layanan/produk-layanan/:id" element={<ProductDetail />} />
        <Route path="/jamu/:id" element={<PlantDetail />} />



        <Route
          path="/dashboard"
          element={
            <ProtectedRoute requiredRole="admin">
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/berita"
          element={
            <ProtectedRoute requiredRole="admin">
              <NewsManagement />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/users"
          element={
            <ProtectedRoute requiredRole="admin">
              <DashboardUserPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/products-list"
          element={
            <ProtectedRoute requiredRole="admin">
              <DashboardProduct />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/product-category"
          element={
            <ProtectedRoute requiredRole="admin">
              <DashboardProductCategory />
            </ProtectedRoute>
          }
        />
        
      
        <Route
          path="/dashboard/services"
          element={
            <ProtectedRoute requiredRole="admin">
              <DashboardServicePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/gallery/photos"
          element={
            <ProtectedRoute requiredRole="admin">
              <DashboardGallery />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/gallery/video"
          element={
            <ProtectedRoute requiredRole="admin">
              <DashboardGalleryVideo />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/services-category"
          element={
            <ProtectedRoute requiredRole="admin">
              <DashboardServiceCategoryPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/content/tentang"
          element={
            <ProtectedRoute requiredRole="admin">
              <DashboardProfile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/content/task"
          element={
            <ProtectedRoute requiredRole="admin">
              <DashboardTask />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/content/fungsi"
          element={
            <ProtectedRoute requiredRole="admin">
              <FunctionManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/content/sejarah"
          element={
            <ProtectedRoute requiredRole="admin">
              <HistoryManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/content/misi"
          element={
            <ProtectedRoute requiredRole="admin">
              <MisiManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/content/visi"
          element={
            <ProtectedRoute requiredRole="admin">
              <VisiManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/content/struktur"
          element={
            <ProtectedRoute requiredRole="admin">
              <OrganizationStructureManagement />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/artikel"
          element={
            <ProtectedRoute requiredRole="admin">
              <ArticleManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/education"
          element={
            <ProtectedRoute requiredRole="admin">
              <EducationFileManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/facility"
          element={
            <ProtectedRoute requiredRole="admin">
              <FacilityManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/artikel-category"
          element={
            <ProtectedRoute requiredRole="admin">
              <ArticleCategoryManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/standar-pelayanan"
          element={
            <ProtectedRoute requiredRole="admin">
              <PublicContentManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/footer/alamat"
          element={
            <ProtectedRoute requiredRole="admin">
              <FooterContent1Management />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/footer/maps"
          element={
            <ProtectedRoute requiredRole="admin">
              <FooterContent2Management/>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/footer/contact"
          element={
            <ProtectedRoute requiredRole="admin">
              <FooterContent3Management/>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/footer/timeline"
          element={
            <ProtectedRoute requiredRole="admin">
              <Contact4Management/>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/footer/social-media"
          element={
            <ProtectedRoute requiredRole="admin">
              <FooterContent6Management/>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/banner"
          element={
            <ProtectedRoute requiredRole="admin">
              <HeroContentManagement/>
            </ProtectedRoute>
          }
        />

        {/* Unauthorized page (optional) */}
        <Route path="/unauthorized" element={<UnauthorizedPage />} />

        {/* Catch-all route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}
export default App;
